export default __webpack_public_path__ + "static/media/arseniologo.8cf792c3.jpeg";